import { types } from 'mobx-state-tree';
import { DistancesKm } from '../search';
import { fetchOptions } from './flows/fetch-config-flow';

export const GeoCoordinate = types.model({
  latitude: types.optional(types.number, 41.8902743),
  longitude: types.optional(types.number, 12.4923553),
});

export const MapBoxConfig = types.model({
  accessToken: types.optional(
    types.string,
    `pk.eyJ1IjoidGQtY2ZtbWVkaWEiLCJhIjoiY2ttYWkyY2gxMXJ4aTJ1cDF4YjJjazJrNiJ9.pBPqoqgLad3jMuW0tdX-hw`,
  ),
  styleUrl: types.optional(
    types.string,
    `mapbox://styles/td-cfmmedia/ckmap1h1mgios17ryfp13dvon`,
  ),
  maxZoomLevel: types.optional(types.number, 9.5),
  searchRadius: types.maybe(DistancesKm),
});

export const SupportedLanguages = types.enumeration('supported-languages', [
  'en',
  'de',
  'fr',
  'nl',
]);

export const GysServiceConfig = types.model({
  language: types.optional(SupportedLanguages, 'en'),
  ownerId: types.string,
  url: types.string,
  useMock: types.optional(types.boolean, false),
  debounceDelay: types.optional(types.number, 1000),
});

export const OptInFeature = types.optional(types.boolean, false);
export const OptOutFeature = types.optional(types.boolean, true);

export const FeatureFlags = types.model({
  favourites: OptInFeature,
  myLocations: OptInFeature,
  search: OptInFeature,
  parking: OptInFeature,
});

export const ConfigStore = types
  .model({
    features: types.optional(FeatureFlags, {}),
    gysService: GysServiceConfig,
    initialPosition: GeoCoordinate,
    mapBox: MapBoxConfig,
    translationUrl: types.string,
  })
  .actions((self) => ({
    afterCreate: (...args) => fetchOptions(self, ...args),
  }));

export const initialState = {
  features: {
    myLocations: true,
    favourites: true,
    search: true,
    parking: true,
  },
  gysService: {
    ownerId: 'test',
    url: 'http://localhost:3000',
    language: 'de',
    useMock: false,
  },
  initialPosition: {},
  mapBox: { maxZoomLevel: 11 },
  translationUrl:
    'https://sunny.get-your-spot.com/api/translations/{{lng}}/{{ns}}',
};
